export var SEND_ABTEST_TOGGLE = 'SEND_ABTEST_TOGGLE';
export var SEND_ABTEST_TOOLTYPE_TOGGLE = 'SEND_ABTEST_TOOLTYPE_TOGGLE';